import React, { Fragment, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import '../../../../BotReport/index.css';

import clientsIcon from '../../../../../../../assets/images/clientes.svg';
import ContainerReport from '../../../../ContainerReport';
import { getCompanyTotalUsersCount } from '../../../../../../../store/actions/reports';

/**
 * Component for show the report data for total of user on company
 *
 * @param {*} props
 * @returns
 */
const OrgTotalUsersReport = (props) => {
  const { componentData, getCompanyTotalUsersCount, match, user, org } = props;
  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { orgId } = match.params;
  const token = user.dashboard_token;

  const [orgTotal, setOrgTotal] = useState(0);

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    getCompanyTotalUsersCount(orgId, token);
  }, [parentFilter]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    setOrgTotal(getOrgBotsTotal());
  }, [org]);

  /**
   * Get the org bots total
   */
  const getOrgBotsTotal = () => {
    if (!org || !Array.isArray(org) || org.length === 0) {
      return 0;
    }
    return org[0].count;
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{orgTotal}</p>
          <span className="tipo-relatorio">Nesta org.</span>
        </div>
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type={'absolute'}
      icon={clientsIcon}
      title={'Total de Usuários'}
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    org: state.reports.orgBotsTotalUsers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCompanyTotalUsersCount }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrgTotalUsersReport)
);
